/**
 * Frontend finance helpers — mirrors backend utils/finance.js for UI calculations.
 */

export function toMoney(value) {
    const num = Number(value);
    if (!Number.isFinite(num)) {
        return 0;
    }
    return Math.round(num * 100) / 100;
}

export function calculateDayPassFinalAmount(
    totalAmount,
    discountApplied = 0,
    extensionFee = 0
) {
    const final =
        toMoney(totalAmount) - toMoney(discountApplied) + toMoney(extensionFee);
    return Math.max(0, final);
}

export function calculateContractPayable({
    totalRent = 0,
    advanceRent = 0,
    securityDeposit = 0,
    oneTimeServiceCharges = 0,
    oneTimeOtherCharges = [],
}) {
    const otherCharges = (oneTimeOtherCharges || []).reduce(
        (sum, charge) => sum + toMoney(charge.amount),
        0
    );

    return toMoney(
        toMoney(totalRent) +
        toMoney(advanceRent) +
        toMoney(securityDeposit) +
        toMoney(oneTimeServiceCharges) +
        otherCharges
    );
}

export function sumMonthlyRent(offices = [], seats = []) {
    const officeRent = offices.reduce(
        (acc, office) => acc + toMoney(office.monthlyRent),
        0
    );
    const seatRent = seats.reduce(
        (acc, seat) => acc + toMoney(seat.monthlyRent),
        0
    );
    return toMoney(officeRent + seatRent);
}
